module.exports = __webpack_public_path__ + "img/SES_220412110.726240ca.jpg";